import { Box, Icon } from '@zillow/constellation-10';
import {
  IconPauseCircleFilled,
  IconUnconstrainedWalkThroughFilled,
  IconUserAddFilled,
} from '@zillow/constellation-icons';

import AnswerCard from './AnswerCard';
import { DEACTIVATION_REASONS } from '../constants';

import { type DeactivationReason } from '../constants';

type DeactivationReasonStepProps = {
  selectedAnswer: DeactivationReason | null;
  onAnswerSelect: (answer: DeactivationReason) => void;
};

const DeactivationReasonStep = ({ selectedAnswer, onAnswerSelect }: DeactivationReasonStepProps) => {
  return (
    <Box data-testid="DeactivationReasonStep" css={{ display: 'flex', flexDirection: 'column', gap: '400' }}>
      <AnswerCard
        data-testid="AnswerCardFoundTenant"
        icon={
          <Icon size="lg">
            <IconUserAddFilled />
          </Icon>
        }
        title="I found a new tenant"
        isSelected={selectedAnswer === DEACTIVATION_REASONS.FOUND_TENANT}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.FOUND_TENANT)}
      />
      <AnswerCard
        data-testid="AnswerCardTenantRenewed"
        icon={
          <Icon size="lg">
            <IconUnconstrainedWalkThroughFilled />
          </Icon>
        }
        title="My current tenant renewed"
        isSelected={selectedAnswer === DEACTIVATION_REASONS.TENANT_RENEWED}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.TENANT_RENEWED)}
      />
      <AnswerCard
        data-testid="AnswerCardStillLookingPausing"
        icon={
          <Icon size="lg">
            <IconPauseCircleFilled />
          </Icon>
        }
        title="I am still looking for a tenant but am pausing this Zillow listing"
        isSelected={selectedAnswer === DEACTIVATION_REASONS.STILL_LOOKING_PAUSING}
        onClick={() => onAnswerSelect(DEACTIVATION_REASONS.STILL_LOOKING_PAUSING)}
      />
    </Box>
  );
};

export default DeactivationReasonStep;
